import { Injectable } from '@angular/core';
import { IEnvironment } from '../models/ienvironment';

@Injectable({
	providedIn: 'root',
})
export class EnvironmentService {
	private static _environment: IEnvironment;

	public static init(environment: IEnvironment) {
		this._environment = environment;
	}
	
	private get _environment(): IEnvironment { return EnvironmentService._environment; }

	constructor() {
		if (!EnvironmentService._environment)
			throw new Error('EnvironmentService._environment is required');
	}
	
	public getFirstTab(){
		const firstTab = this._environment.bottomTabs[0];
		return firstTab;
	}
	
	public isMenuEnabled(){
		return this._environment.bottomTabs.includes('menu')
			|| this._environment.topTabs.includes('menu');
	}

	public isMenuInBottomEnabled(){
		return this._environment.bottomTabs.includes('menu');
	}
	
	public isGalleryEnabled(){
		return this._environment.bottomTabs.includes('gallery')
			|| this._environment.topTabs.includes('gallery');
	}
	
	public isArchiveEnabled(){
		return this._environment.bottomTabs.includes('archive')
			|| this._environment.topTabs.includes('archive');
	}
	
	public isSeminarsEnabled(){
		return this._environment.bottomTabs.includes('seminars')
			|| this._environment.topTabs.includes('seminars');
	}
	
	public isAppointmentsEnabled(){
		return this._environment.bottomTabs.includes('appointments')
			|| this._environment.topTabs.includes('appointments');
	}
}
